{
  "BoundInteger": {
    "type": "input",
    "layout": [
      {
        "grid": 12,
        "label": "Bound Integer",
        "inputType": "integer",
        "maxNumber": 50,
        "minNumber": 0,
        "valueName": "boundInt",
        "defaultValue": ""
      }
    ]
  },
  "UnboundInteger": {
    "type": "input",
    "layout": [
      {
        "grid": 12,
        "label": "Unbound Integer",
        "inputType": "integer",
        "valueName": "unboundInt",
        "defaultValue": ""
      }
    ]
  },
  "MixedInteger": {
    "type": "input",
    "layout": [
      {
        "grid": 12,
        "label": "Unbound Integer",
        "inputType": "integer",
        "valueName": "unboundInt",
        "defaultValue": ""
      },
      {
        "grid": 12,
        "label": "Bound Integer",
        "inputType": "integer",
        "maxNumber": 50,
        "minNumber": 0,
        "valueName": "boundInt",
        "defaultValue": ""
      }
    ]
  },
  "MixedNumberSideBySide": {
    "type": "input",
    "layout": [
      {
        "grid": 6,
        "label": "Unbound Integer",
        "inputType": "integer",
        "valueName": "unboundInt",
        "defaultValue": ""
      },
      {
        "grid": 6,
        "label": "Bound Decimal",
        "inputType": "decimal",
        "maxNumber": 50.40,
        "minNumber": 0,
        "precision": 3,
        "valueName": "boundDecimal",
        "defaultValue": 1.5
      }
    ]
  },
  "SelectDropdown": {
    "type": "input",
    "layoutSize": "sm",
    "layout": [
      {
        "grid": 12,
        "label": "Select Something",
        "inputType": "select",
        "selectValues": [
          {
            "label": "Option 1",
            "value": "opt1"
          },
          {
            "label": "Option 2",
            "value": "opt2"
          },
          {
            "label": "Option 3",
            "value": "opt3"
          }
        ],
        "valueName": "selectValue",
        "defaultValue": "opt1"
      }
    ]
  },
  "Tabs": {
    "type": "input",
    "layoutSize": "md",
    "tabs": [
      {
        "label": "Apples",
        "layout": [
          {
            "grid": 6,
            "label": "Select Something",
            "required": true,
            "inputType": "select",
            "selectValues": [
              {
                "label": "Option 1",
                "value": "opt1"
              },
              {
                "label": "Option 2",
                "value": "opt2"
              },
              {
                "label": "Option 3",
                "value": "opt3"
              }
            ],
            "valueName": "selectValue",
            "defaultValue": "opt1"
          },
          {
            "grid": 6,
            "label": "Unbound Integer",
            "inputType": "integer",
            "valueName": "unboundInt",
            "defaultValue": ""
          },
          {
            "grid": 12,
            "label": "Dollar Amount",
            "valuePrefixLabel": "$",
            "valueSuffixLabel": "USD",
            "inputType": "decimal",
            "maxNumber": 49.99,
            "minNumber": 0,
            "precision": 2,
            "valueName": "someDollarAmount",
            "defaultValue": "1.50"
          }
        ]
      },
      {
        "label": "Oranges",
        "layout": [
          {
            "grid": 12,
            "label": "Unbound Integer",
            "inputType": "integer",
            "valueName": "unboundInt",
            "defaultValue": ""
          },
          {
            "grid": 4,
            "label": "Date",
            "inputType": "date",
            "valueName": "datePicker",
            "defaultValue": ""
          },
          {
            "grid": 4,
            "label": "I like turtles",
            "inputType": "checkbox",
            "valueName": "checkboxTurtles",
            "defaultValue": false,
            "required": true
          },
          {
            "grid": 4,
            "label": "Text",
            "inputType": "text",
            "valueName": "someText",
            "defaultValue": "just a default",
            "required": true,
            "maxLength": 20
          },
          {
            "grid": 8,
            "label": "Multiline Text",
            "inputType": "textarea",
            "valueName": "multilineTextarea",
            "defaultValue": "4 rows",
            "rows": 4
          },
          {
            "grid": 4,
            "label": "Smaller one",
            "inputType": "textarea",
            "valueName": "multilineTextarea2",
            "defaultValue": "2 rows",
            "rows": 2,
            "maxLength": 100
          }
        ]
      }
    ]
  },
  "TabsAllValues": {
    "type": "input",
    "saveAllTabValues": true,
    "layoutSize": "lg",
    "tabs": [
      {
        "label": "Apples",
        "layout": [
          {
            "grid": 6,
            "label": "Select Something",
            "required": true,
            "inputType": "select",
            "selectValues": [
              {
                "label": "Option 1",
                "value": "opt1"
              },
              {
                "label": "Option 2",
                "value": "opt2"
              },
              {
                "label": "Option 3",
                "value": "opt3"
              }
            ],
            "valueName": "selectValue",
            "defaultValue": "opt1"
          },
          {
            "grid": 6,
            "label": "Unbound Integer",
            "inputType": "integer",
            "valueName": "unboundInt",
            "defaultValue": ""
          },
          {
            "grid": 12,
            "label": "Dollar Amount",
            "valuePrefixLabel": "$",
            "valueSuffixLabel": "USD",
            "inputType": "decimal",
            "maxNumber": 49.99,
            "minNumber": 0,
            "precision": 2,
            "valueName": "someDollarAmount",
            "defaultValue": "1.50"
          }
        ]
      },
      {
        "label": "Oranges",
        "layout": [
          {
            "grid": 12,
            "label": "Unbound Integer",
            "inputType": "integer",
            "valueName": "unboundInt",
            "defaultValue": ""
          },
          {
            "grid": 4,
            "label": "Date",
            "inputType": "date",
            "valueName": "datePicker",
            "defaultValue": ""
          },
          {
            "grid": 4,
            "label": "I like turtles",
            "inputType": "checkbox",
            "valueName": "checkboxTurtles",
            "defaultValue": false,
            "required": true
          },
          {
            "grid": 4,
            "label": "Text",
            "inputType": "text",
            "valueName": "someText",
            "defaultValue": "just a default",
            "required": true,
            "maxLength": 20
          },
          {
            "grid": 8,
            "label": "Multiline Text",
            "inputType": "textarea",
            "valueName": "multilineTextarea",
            "defaultValue": "4 rows",
            "rows": 4
          },
          {
            "grid": 4,
            "label": "Smaller one",
            "inputType": "textarea",
            "valueName": "multilineTextarea2",
            "defaultValue": "2 rows",
            "rows": 2,
            "maxLength": 100
          }
        ]
      }
    ]
  }
}
